<template>

    <div class="overlay fixed top-0 bottom-0 left-0 right-0 z-[200] flex justify-center items-center bg-[#0204167A]">

        <div class="w-[335px] bg-white rounded-md overflow-hidden">

            <div class="py-7 px-6">
                <h5 class="text-lg font-bold text-center pb-2" v-if="title">{{ title }}</h5>
                <div class="max-h-[352px] overflow-y-auto">
                    <slot></slot>
                </div>
            </div>


            <div class="flex">

                <template v-if="type === 'confirm'">
                    <button class="py-4 w-1/2 bg-[#CCF3FF] text-[#0093C1] font-semibold"
                        @click="(e) => { confirm(false) }">{{ buttonText?.no || '取消' }}</button>
                </template>

                <button :class="(type === 'confirm') ? 'w-1/2' : 'w-full'" :disabled="disableConfirmBtn"
                    class="py-4 bg-[#0093C1] text-white font-semibold disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                    @click="(e) => { confirm(true) }">{{
                        (typeof buttonText === 'string' ? buttonText : buttonText?.yes) || '確定' }}</button>

            </div>
        </div>

    </div>

</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    title: String,
    closeHandel: Function,
    okHandel: Function,
    cancelHandel: Function,
    buttonText: [Object, String],
    type: String,
    disableConfirmBtn: {
        type: Boolean,
        default: false,
    }
});

async function confirm(state) {
    if (state) {
        if (props.okHandel) {
            await props.okHandel();
        }
    } else {
        if (props.cancelHandel) {
            await props.cancelHandel();
        }
    }
    props.closeHandel();
};

</script>

<style scoped></style>
